import React from 'react'
import styled from 'styled-components'
import {injectIntl} from 'react-intl'
import Button from '@mui/material/Button'

const Container = styled.div`
    width: 33%;
    display: flex;
    flex-direction: column;
    padding: 15px;
    position: relative;
    height: 225px;
    box-sizing: border-box;

    button {
        margin-top: auto;
        padding: 5px 10px;
    }

    > div {
        color: rgba(50, 50, 50, .8);
        transition: color .3s cubic-bezier(.55, 0, .1, 1);
    }

    :hover {
        span:first-child {
            opacity: 1;
        }

        span:nth-child(2) {
            opacity: 0;
        }

        div {
            color: rgba(70, 70, 70, .95);
        }
    }
`

const Title = styled.div`
    font-weight: 700;
    margin-bottom: 20px;
`

const Description = styled.div`
    margin-bottom: 20px;
`

const Img = styled.div`
    position: relative;
    height: 110px;
    margin-top: -15px;

    > span {
        position: absolute;
        top: 0;
        transition: opacity .3s cubic-bezier(.55, 0, .1, 1);
    }

    > span:first-child {
        opacity: 0;
    }

    > span:nth-child(2) {
        opacity: 1;
    }
`

export default injectIntl(({icon, name, color, title, onClick, intl}) => 
    <Container>
        {title && <Title>{intl.formatMessage({id: `main.entity_title_${name}`})}</Title>}
        <Img>
            <span className={"entity-icon-large entity-icon-" + icon} />
            <span className={"entity-icon-large entity-icon-" + icon + "-mono"} />
        </Img>
        <Description>{intl.formatMessage({id: `main.entity_description_${name}`})}</Description>
        <Button variant="contained"
            onClick={onClick}
            color="primary"
            style={color ? {backgroundColor: color} : {}}
        >
            {intl.formatMessage({id: `main.create_${name}`})}
        </Button>
    </Container>
)
